import SectionList from "./SectionList";
import { Container } from "react-bootstrap";
const Front = ({toogleMode,main, mode}) => {
    return (  <Container fluid className="front-container"><div id="front">
        <SectionList main={main}  mode={mode} toogleMode={toogleMode}/>
    </div>
    </Container>) 
}
export default Front;